<template>
    <div class="creatSuccess">
        <el-dialog title="" :visible.sync="isShow" :before-close="handleClose">
            <div class="creat_box">
                <img :src="successIcon" alt="">
                <p class="title">你已成功创建直播</p>
                <p>您还可以进行更多的关于直播的相关设置</p>
                <div class="codeImg">
                    <img :src="shareurl" alt="">
                    <p>微信扫码立即查看直播</p>
                </div>
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="goTools">去直播</el-button>
            </div>
        </el-dialog>
        <LiveTools ref="liveTools"></LiveTools>
    </div>
</template>

<script>
    import LiveTools from '@/views/vliveV2/components/liveTools'
    import {urlToQRCode} from 'common/js/tools'
    export default {
        name: "creatSuccess",
        data(){
            return{
                successIcon:require('@/common/images/vliveV2/successIcon.png'),
                isShow:false,
                shareurl:'',
                liveid:'',
            }
        },
        methods:{
            open(shareurl,liveid){
                this.isShow=true;
                this.shareurl = urlToQRCode(shareurl);
                this.liveid=liveid
            },
            cancel(){
                this.isShow=false;
                this.$router.push({name: 'LiveList'})
            },
            handleClose(){
                this.isShow=false;
                this.$router.push({name: 'LiveList'})
            },
            //去直播
            goTools(){
                this.$refs.liveTools.open(this.liveid);
            },
        },
        components: {
            LiveTools
        }
    }
</script>

<style lang="scss">
    .creatSuccess{
        .el-dialog {
            .el-dialog__header{
                border-bottom: none!important;
            }
        }
        .creat_box{
            text-align: center;
            .title{
                font-size: 24px;
                color: #333;
                margin-top: 24px;
                margin-bottom: 10px;
            }
            .codeImg{
                width:252px;
                height:208px;
                border-radius:1px;
                border:1px solid rgba(220,223,230,1);
                margin: 40px auto;
                img{
                    width:140px;
                    height:140px;
                    margin-bottom: 10px;
                    display: inline-block;
                    margin-top: 20px;
                }
            }
        }
    }
</style>
